import IMGURL from "../../../../config/imgUrl"

export default [
	{
		name: '标签',
		url: IMGURL.textImgUrl,
		type: "dynamicLabel",
		wrapperStyle: {
			width: '100px',
			height: '40px',
			'z-index': 10,
		},
		style: {
			width: '100px',
			height: '40px',
			'background-color': '#eeece1',
			'font-size': '17px',
			'font-family': 'Arial',
			'border-width': '1px',
			'border-style': 'solid',
			'border-color': '#000000',
			'color': '#000000',
			'z-index': 10,
		},
		settings: {  // settings存放内容为 字符串or对象信息
			width: '100',
			height: '40',
			text: '标签',  // or {'varName': 'v1', ...}
			time:false,
			bindVar: '',
			editable: false,
			textColor: '#000000',
			textSize: '17',
			textStyle: 'Arial',
			labelColor: '#eeece1',
			borderColor: '#000000',
			borderWidth: '1',
			showLabelBorder: true,
			transparentBackground: false,
			state: true,
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData: {  // 只存放当前数值
			width: '100',
			height: '80',
			text: '标签',  // 展示数值，create中进行定时更新
			time:false,
			bindVar: '',
			editable: false,
			textColor: '#000000',
			textSize: '17',
			textStyle: 'Arial',
			labelColor: '#eeece1',
			borderColor: '#000000',
			borderWidth: '1',
			showLabelBorder: true,
			transparentBackground: false,
			state: true,
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '按钮',
		url: IMGURL.buttonImgUrl,
		type: "button",
		wrapperStyle: {
			width: '100px',
			height: '50px',
			'z-index': 10,
		},
		style: {
			width: '100px',
			height: '50px',
			'font-size': '17px',
			'font-family': 'Arial',
			'color': '#000000',
			'text-decoration': 'none',
			'justify-content': 'center',
			'box-shadow': 'none',

			'background-color':'#c62d1f',
			'border-color': '#d02718',
			'animation-duration': '0.5s',
			'animation-play-state': 'paused',
			'z-index': 10,
		},
		settings: {
			width: '100',
			height: '50',
			text: '按钮',
			txtColor: '#000000',
			txtSize: 17,
			txtStyle: 'Arial',
			txtDecoration: 'none',
			txtPosition: 'center',
			btnColor: '#c62d1f',
			btnBorderColor: '#d02718',
			btnEffectColor: '#8a2a21',
			flash: false,
			state: true,
			pageId: '',       //跳转的页面的Id
			selectValue1:'',  //跳转方式选择 模态/非模态
			selectValue2:'',  //跳转页面的类型
			modalValue:'',   //模态窗宽度
			modalHeight:'', //模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			varIds:[], //传递的变量数组
			flag: false,
			isLock: false,
		},
		realtimeData: {
			width: '100',
			height: '50',
			text: '按钮',
			txtColor: '#000000',
			txtSize: 17,
			txtStyle: 'Arial',
			txtDecoration: 'none',
			txtPosition: 'center',
			btnColor: '#c62d1f',
			btnBorderColor: '#d02718',
			btnEffectColor: '#8a2a21',
			flash: false,
			state: true,
			pageId: '',
			flag: false,
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '图片',
		url: IMGURL.imageImgUrl,
		type:"img",
		wrapperStyle:{
			width:'100px',
			height:'100px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style:{
			width:'100px',
			height:'100px',
			'z-index': 10,
		},
		settings: {  // 存放绑定对象，字符串 or 对象信息
			width: '100',
			height: '100',
			imgName: "",
			state: true,
			imgDirection: "0",
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData: {  // 存放真实数据
			width: '100',
			height: '100',
			state: true,
			imgDirection: "0",
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '水流',
		url: IMGURL.pipelineImgUrl,
		type: "WaterLine",
		wrapperStyle: {
			width: '200px',
			height: '20px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style: {
			width: '200px',
			height: '20px',
			background: 'white',
			border: 'solid 2px',
			'z-index': 10,
		},
		settings: {  // 存放绑定对象，字符串 or 对象信息
			width: '200',
			height: '20',
			direction: 'leftToRight', // 'leftToRight' || 'rightToLeft' || 'topToBottom' || 'bottomToTop'
			transform: 'rotate(0deg)',
			background: "#0000ff",
			animationDuration: "1s",
			speed: 1,
			borderColor: "#0000ff",
			state: true,
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData: {  // 存放真实数据
			width: '200',
			height: '20',
			direction: 'leftToRight', // 'leftToRight' || 'rightToLeft' || 'topToBottom' || 'bottomToTop'
			transform: 'rotate(0deg)',
			background: "#0000ff",
			animationDuration: '1s',
			speed: 1,
			borderColor: "#0000ff",
			state: true,
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '矩形',
		url: IMGURL.rectangleImgUrl,
		type:"rectangle",
		wrapperStyle: {
			width: '200px',
			height: '100px',
			// top: '100px',
			// left:'300px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style:{
			width: '200px',
			height: '100px',
			// top: '100px',
			// left:'300px',
			'border-width': '1px', //边框宽度
			'border-color': '#000000', //边框颜色
			'border-style': 'solid', //边框类型
			'background-color': '#9aba60', //填充颜色
			'animation-duration': '0.5s',
			'animation-play-state': 'paused',
			state: true,
			'z-index': 10,
		},
		realtimeData:{
			width: '200',
			height: '100',
			// top: '100',
			// left:'300',
			rectangleColor: '#9aba60',//填充颜色
			backColor: '#FFFFFF',     //背景颜色
			borderStyle: 'solid', //边框类型
			borderColor: '#000000',//边框颜色
			borderWidth: '1',//边框宽度
			mode: 'vertical',
			recDirection: false,
			flash: false,
			state: true,
			pageId: '',
			flag: false,
			myVar: '',
			extendValue: 0,       // 延伸的值
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		settings:{
			width: '200',
			height: '100',
			// top: '100',
			// left:'300',
			rectangleColor: '#9aba60',//填充颜色
			backColor: '#FFFFFF',     //背景颜色
			borderStyle: 'solid', //边框类型
			borderColor: '#000000',//边框颜色
			borderWidth: '1',//边框宽度
			mode: 'vertical',
			recDirection: false,
			flash: false,
			state: true,
			myVar: '',
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
			isLock: false,
			extendDirection: 'left',    //延伸的方向
			extendValue: 0,       // 延伸的值
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '圆形',
		url: IMGURL.circleImgUrl,
		type:"circle",
		wrapperStyle:{
			width: '100px',
			height: '100px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style:{
			width: '100px',
			height: '100px',
			'border-width': '1px', //边框宽度
			'border-color': '#000000', //边框颜色
			'border-style': 'solid', //边框类型
			'background-color': '#9aba60', //填充颜色
			'border-radius': '50%',
			'animation-duration': '0.5s',
			'animation-play-state': 'paused',
			extendDirection: 'left',    //延伸的方向
			extendValue: 0,       // 延伸的值
			dx: 0,
			dy: 0,
			dw: 0,
			dh: 0,
			'z-index': 10,
		},
		settings:{
			width: '100',
			height: '100',
			circleColor: '#9aba60',
			borderWidth: '1',
			borderStyle: 'solid',
			borderColor: '#000000',
			flash: false,
			state: true,
			dynamicText: '',
			myVar: '',
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData:{
			width: '100',
			height: '100',
			circleColor: '#9aba60',
			borderWidth: '1',
			borderStyle: 'solid',
			borderColor: '#000000',
			flash: false,
			state: true,
			dynamicText: '',
			myVar: '',
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '彩轮',
		url: IMGURL.wheelImgUrl,
		type:"wheel",
		wrapperStyle:{
			width:'100px',
			height:'100px',
			'z-index': 10,
		},
		style:{
			width:'100px',
			height:'100px',
			'border-radius': '50%',
			'border-style': 'solid',
			'border-width': '1px',
			'border-color': '#000000',
			'animation-duration':'10s',
			'animation-direction': 'normal',
			'animation-play-state': 'running',
			background: '#eeece1',
			'z-index': 10,
		},
		settings:{
			width:'100',
			height:'100',
			borderColor: '#000000',
			background: '#eeece1',
			background1:'#e2534d',
			background2:'#ffff3a',
			background3:'#9aba60',
			background4:'#8165a0',
			animationDuration: '10',
			animationDirection: 'clockWise', // normal || reverse
			rotateState: true,
			state: true,
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData:{
			width:'100',
			height:'100',
			borderColor: '#000000',
			background: '#eeece1',
			background1:'#e2534d',
			background2:'#ffff3a',
			background3:'#9aba60',
			background4:'#8165a0',
			animationDuration: '10',
			animationDirection: 'clockWise', // normal || reverse
			rotateState: true,
			state: true,
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '箭头',
		url: IMGURL.arrowImgUrl,
		type:"arrow",
		wrapperStyle:{
			width: '40px',
			height: '80px',
			'min-width': "0px",
			'min-height': "0px",
			'z-index': 10,
		},
		style:{
			width: '40px',
			height: '80px',
			'background-color': '#9aba60', //填充颜色
			//裁剪的几个点的位置
			'clip-path': 'polygon(0 40%,30% 40%,30% 100%,70% 100%,70% 40%,100% 40%,50% 0)',
			'animation-duration': '0.5s',
			'animation-play-state': 'paused',
			'z-index': 10,
		},
		settings:{
			width: '40px',
			height: '80px',
			color: '#9aba60',
			arrowDirection: 'up',
			flash: false,
			state: true,
			dynamicText: '', //变量数值
			myVar: '', //记录闪烁
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData:{
			width: '40px',
			height: '80px',
			color: '#9aba60',
			arrowDirection: 'up',
			flash: false,
			state: true,
			dynamicText: '', //变量数值
			myVar: '', //记录闪烁
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '三角',
		url: IMGURL.triangleImgUrl,
		type:"triangle",
		wrapperStyle:{
			width: '50px',
			height: '50px',
			'min-width': "0px",
			'min-height': "0px",
			'z-index': 10,
		},
		style:{
			width: '50px',
			height: '50px',
			'background-color': '#9aba60', //填充颜色
			'clip-path': 'polygon(50% 0, 0 100%, 100% 100%)',
			'animation-duration': '0.5s',
			'animation-play-state': 'paused',
			'z-index': 10,
		},
		settings:{
			width: '50',
			height: '50',
			color: '#9aba60',
			triangleDirection: 'up',
			flash: false,
			state: true,
			dynamicText: '', //变量数值
			myVar: '', //记录闪烁
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData:{
			width: '50',
			height: '50',
			color: '#9aba60',
			triangleDirection: 'up',
			flash: false,
			state: true,
			dynamicText: '', //变量数值
			myVar: '', //记录闪烁
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	//插入图片
	{
		name: '管道',
		url: IMGURL.crossImgUrl,
		type:"crossTwo",
		wrapperStyle:{
			width:'100px',
			height:'20px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style:{
			width:'100px',
			height:'20px',
			pipelineDirection: 'right',
			pipelineDiameter: 'same',
			'clip-path': 'polygon( 0 0, 100% 0, 100% 100%, 0 100%)',
			'background': 'linear-gradient(to bottom,  #1e497b, white, #1e497b)',
			'z-index': 10,
		},
		settings:{
			width: '100',
			height: '20',
			pipelineColor: '#1e497b',
			pipelineDirection: 'right',
			pipelineDiameter: 'same',
			state: true,
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData:{
			width: '100',
			height: '20',
			pipelineColor: '#1e497b',
			pipelineDirection: 'right',
			pipelineDiameter: 'same',
			state: true,
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '直角',
		url: IMGURL.cross2ImgUrl,
		type:"crossTwoAngle",
		wrapperStyle:{
			width:'60px',
			height:'60px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style:{
			width:'60px',
			height:'60px',
			background: 'white',
			'z-index': 10,
		},
		settings: {  // 存放绑定对象，字符串 or 对象信息
			width: '60',
			height: '60',
			direction: '0',
			transform: 'rotate(0deg)',
			background: "#1e497b",
			state: true,
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData: {  // 存放真实数据
			width: '60',
			height: '60',
			direction: '0',
			transform: 'rotate(0deg)',
			background: "#1e497b",
			state: true,
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '三通',
		url: IMGURL.cross3ImgUrl,
		type:"crossThree",
		wrapperStyle:{
			width:'100px',
			height:'60px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style:{        // 组件在页面展示的样式
			width:'100px',
			height:'60px',
			background: 'white',
			'z-index': 10,
		},
		settings: {  // 存放绑定对象，字符串 or 对象信息
			width: '100',
			height: '60',
			top: '0',
			left: '0',
			direction: '0',
			transform: 'rotate(0deg)',
			background: "#1e497b",
			state: true,
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData: {  // 存放真实数据
			width: '100',
			height: '60',
			direction: '0',
			transform: 'rotate(0deg)',
			background: "#1e497b",
			state: true,
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '四通',
		url: IMGURL.cross4ImgUrl,
		type:"crossFour",
		wrapperStyle:{
			width:'100px',
			height:'100px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style:{
			width:'100px',
			height:'100px',
			background: 'white',
			'z-index': 10,
		},
		settings: {  // 存放绑定对象，字符串 or 对象信息
			width: '100',
			height: '100',
			background: "#1e497b",
			state: true,
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
		},
		realtimeData: {  // 存放真实数据
			width: '100',
			height: '100',
			background: "#1e497b",
			state: true,
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	},
	{
		name: '视频',
		url: IMGURL.videoCameraUrl,
		type:"camera",
		wrapperStyle:{
			width:'300px',
			height:'400px',
			'min-width': "1px",
			'min-height': "1px",
			'z-index': 10,
		},
		style:{
			width:'300px',
			height:'400px',
			background: 'white',
			'z-index': 10,
		},
		settings: {  // 存放绑定对象，字符串 or 对象信息
			width: '300',
			height: '400',
			state: true,
			isLock: false,
			pageId: '',       	//跳转的页面的Id
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
			flag: false,
			sn: "",            // 绑定的设备序列号
		},
		realtimeData: {  // 存放真实数据
			width: '300',
			height: '400',
			state: true,
			sn: "",            // 绑定的设备序列号
			selectValue1:'',  	//跳转方式选择 模态/非模态
			selectValue2:'',  	//跳转页面的类型
			modalValue:'',   	//模态窗宽度
			modalHeight:'', 	//模态窗高度
			modalX:'',//模态窗x
			modalY:'',//模态窗y
		},
		events: [],
		variableEvents: [],
	}
]